'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Paper = require('./Paper');

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Paper2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/Paper/index.js
 ** module id = 120
 ** module chunks = 0
 **/